export const Cdata = [
  {
    cid: 1,
    Cname: `"The Galaxy Raven"`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_3.jpg",
  },
  {
    cid: 2,
    Cname: `"Portrait Astrid"`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_2.jpg",
  },
  {
    cid: 3,
    Cname: `" CR7 - Portrait "`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_3.jpg",
  },
  {
    cid: 4,
    Cname: `" family insider "`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_2.jpg",
  },
  {
    cid: 5,
    Cname: `" Sculpture Zeus "`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_3.jpg",
  },
  {
    cid: 6,
    Cname: `“ Totò & Eduardo De Filippo “`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_4.jpg",
  },
  {
    cid: 7,
    Cname: `“ Family first “`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_2.jpg",
  },
  {
    cid: 8,
    Cname: `""`,
    Cimg: "https://falstaff.b-cdn.net/storage/sites/2/2021/01/LIVING_ArtbyRaff_4.jpg",
  },
];
